module.exports = __webpack_public_path__ + "img/JOC_3785.2ac62bc5.jpg";